import { EventEmitter, Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { constant } from '../../app.constants';
import { ITripRiderRequest } from '../../core/interfaces/trip-rider-request.interface';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { of } from 'rxjs/observable/of';

@Injectable()
export class ReservationService extends ParentService {
  riderSelected$ = new EventEmitter<any>();
  reloadTrips$ = new EventEmitter<boolean>();
  reservationData$ = new BehaviorSubject<any>(null);
  standingOrderDate$ = new BehaviorSubject<any>(null);
  saveEditTime$ = new EventEmitter<boolean>();
  reloadReservation$ = new EventEmitter<boolean>();
  reloadTotalAmountSubject = new BehaviorSubject<boolean>(false);
  reloadTotalAmount$ = this.reloadTotalAmountSubject.asObservable();
  tabSelectedSubject$ = new BehaviorSubject<{ numberTab: number, nameTab: string }>(null);
  tabSelected$ = this.tabSelectedSubject$.asObservable();
  riderSelectedSubject = new BehaviorSubject<{ id: number }>(null);
  riderSelectedObs$ = this.riderSelectedSubject.asObservable();
  providerSelectedSubject = new BehaviorSubject<{ id: number }>(null);
  providerSelectedObs$ = this.providerSelectedSubject.asObservable();
  companySelectedSubject = new BehaviorSubject<{ id: number }>(null);
  companySelectedObs$ = this.companySelectedSubject.asObservable();
  tripReasonTransport = new BehaviorSubject<{ id: number }>(null);
  tripReasonTransport$ = this.tripReasonTransport.asObservable();
  isManifestReview = new BehaviorSubject<{ reviewmanifest: boolean }>(null);
  isManifestReview$ = this.isManifestReview.asObservable();
  closeModalDriverManifest = new BehaviorSubject<{ closeModal: boolean }>(null);
  closeModalDriverManifest$ = this.closeModalDriverManifest.asObservable();
  private claimGridLocalUpdate = new Subject<{
    tripid: number;
  }>();
  claimGridLocalUpdate$ = this.claimGridLocalUpdate.asObservable();
  private riderData = new Subject<ITripRiderRequest>();
  riderData$ = this.riderData.asObservable();
  private modelEncounter = new BehaviorSubject<{
    tripId: number;
    tripPaymentDate: string;
    encounterStatus: string;
  }>({
    tripId: null,
    tripPaymentDate: '',
    encounterStatus: '',
  });
  modelEncounter$ = this.modelEncounter.asObservable();
  private standingOrderTrips = new BehaviorSubject<any>(null);
  standingOrderTrips$ = this.standingOrderTrips.asObservable();

  private driverAndVehicleIdByEditDriverVehicleComponentSubject = new BehaviorSubject<{ vehicleId: number, driverId: number }>(null);
  driverAndVehicleIdByEditDriverVehicleComponent$ = this.driverAndVehicleIdByEditDriverVehicleComponentSubject.asObservable();

  private updateEncounterHistory = new BehaviorSubject<number | null>(null);
  updateEncounterHistory$ = this.updateEncounterHistory.asObservable();

  private isReadOnlySubject = new BehaviorSubject<boolean>(false);
  isReadOnly$ = this.isReadOnlySubject.asObservable();

  private pendingReservationSubject = new BehaviorSubject<any>(null);
  pendingReservation$ = this.pendingReservationSubject.asObservable();

  setPendingReservation(value: any) {
    this.pendingReservationSubject.next(value);
  }

  getPendingReservation() {
    return this.pendingReservationSubject.getValue();
  }

  clearPendingReservation() {
    this.pendingReservationSubject.next(null);
  }

  persistPendingReservation() {
    const value = this.pendingReservationSubject.getValue();
    if (value) {
      localStorage.setItem('pendingReservation', JSON.stringify(value));
    }
  }

  constructor(private http: Http, private route: Router) {
    super();
    // this.verifyToken(this.http, route);
  }

  /**
   * @description
   * @returns {any}
   */
  getTripReason() {
    return this.http.get(constant.URL_REASON_TRANSPORT, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @description
   */
  getUserInfo() {
    return this.http.get(constant.URL_USER_PROFILE, this.getHeader()).
    map(resp => resp.json());
  }

  getVehiclesByCompany(company) {
    return this.http.get(constant.URL_VEHICLE + '/Company/' + company, this.getHeader()).
    map(res => res.json());

  }

  getVehicleByProviderNoOndemand(companyid, order?: boolean) {
    return this.http.get(
      constant.URL_VEHICLE_GET_BY_PROVIDERID + `${companyid}&vehicleCycleId=&orderByDriver=${order === false ? false : true}`,
      this.getHeader()).
    map(res => res.json());
  }

  getVehicleById(id: number) {
    return this.http
      .get(constant.URL_VEHICLE + '/' + id,  this.getHeader())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));

  }

  getDriversMCT(driverid: number) {
    return this.http
      .get(constant.URL_DRIVERS + '/' + driverid, this.getHeader())
      .map(res => res.json());
  }

  /**
   *
   * @param payorid
   * @param riderPayorId
   * @param dateOfService
   * @param billingSchedule
   */
  getPayorReasonForTransport(payorid, riderPayorId, dateOfService, billingSchedule?) {
    let urlComplete = `${payorid}?riderPayorId=${riderPayorId}&dateOfService=${dateOfService}`;
    if (billingSchedule) {
      urlComplete += `&changeBillingSchedule=true`;
    }
    const url = constant.URL_REASON_TRANSPORT_LIST + '/' + urlComplete;
    return this.http.get(url, this.getHeader())
      .map(resp => resp.json())
      .catch(error => Observable.throw(error.json()));
  }

  /**
   * @description
   * @param vehicle
   */
  getVehiclesByDriver(vehicle) {
    return this.http.get(constant.URL_VEHICLE + '/' +
      vehicle, this.getHeader()).map(res => res.json());
  }

  /**
   * @description
   * @param riderId
   */
  loadRider(riderId) {
    return this.http.get(constant.URL_RIDER + '/' + riderId, this.getHeader()).
    map(resp => resp.json());
  }

  /**
   * @description
   * @param data
   */
  postNewSO(data) {
    const body = JSON.stringify(data);
    return this.http.post(constant.URL_POST_NEW_SO, body,
        this.headerPost())
      .map(resp => resp.json())
      .catch(error => this.validate401Error(error, this.route));
  }

  /**
   * @description
   * @param data
   */
  postReservation(data) {
    const bodyString = JSON.stringify(data);
    return this.http.post(constant.URL_TRIPS_REGISTERS, bodyString, this.headerPost())
      .map(resp => resp.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * @param originLat
   * @param originLong
   * @param destinationLat
   * @param destinationLong
   */
  calculateDistanceMatrix(originLat, originLong, destinationLat, destinationLong, googleOrdrGuid) {
    let url;

    if (!(originLat && originLong && destinationLat && destinationLong)) {
      return of(null);
    }

    url = constant.URL_DISTANCE_MATRIX + '?origins=' + originLat + ',' +
    originLong + '&destinations=' + destinationLat + ',' + destinationLong;

    if (googleOrdrGuid) {
      url += '&googleOrderGuid=' + googleOrdrGuid;
    }

    return this.http.get(url, this.getHeader())
      .map(resp => resp.json());
  }
  /**
   * @description
   * @param address
   * @param isGoogle
   * @returns {Observable<any>}
   */
  getLocationMapboxGoogle(address, isGoogle) {
    return this.http.get(constant.URL_GET_LOCATION_MAPBOX_GOOGLE + '?query=' + address + '&onlyGoogle=' + isGoogle, this.getHeader())
      .map(resp => resp.json());
  }



  /**
   * @description
   * @returns {Observable<any>}
   */
  getSignReason(showInactive = false): Observable<any> {
    return this.http
      .get(constant.URL_REASON_SIGN + '?showInactive=' + showInactive, this.getHeader())
      .map((response: any) => response.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @description
   * @param vehicleId
   * @param tripId
   * @returns {Observable<any>}
   */
  getDriverByVehicle(vehicleId, tripId) {
    return this.http.get(constant.URL_DRIVERS_BY_VEHICLE + vehicleId + '/' + tripId, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @description
   * @returns {Observable<any>}
   */
  getCancelReason() {
    return this.http.get(constant.URL_CANCEL_REASON, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @description
   * @param {string} ptr
   * @returns {Observable<any>}
   */
  getRiderByPtr(ptr: string, inactive?: boolean) {
    return this.http.get(constant.URL_TRIP_SEARCH + '/' + ptr + '?allRiders=' + inactive, this.getHeader())
      .map(resp => resp.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * @description
   * @returns {Observable<any>}
   */
  getTripStatus() {
    return this.http.get(constant.URL_TRIP_STATUS, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @description
   * @param tripId
   * @returns {Observable<any>}
   */
  getTripHistory(tripId) {
    return this.http.get(constant.URL_TRIP_HISTORY + tripId, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @description
   * @param {number} riderId
   * @returns {Observable<any>}
   */
  getTripById(riderId: number) {
    return this.http.get(constant.URL_TRIP_SEARCH_BY_ID + riderId, this.getHeader())
      .map(resp => resp.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * @description
   * @returns {Observable<any>}
   */
  getTripModifiers() {
    return this.http.get(constant.URL_MODIFIERS, this.getHeader())
      .map(resp => resp.json());
  }

  getTripModifiersByReason(reasonId: number) {
    return this.http
      .get(`${constant.URL_MODIFIERS}?reason=${reasonId}`, this.getHeader())
      .map((response) => response.json())
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * @description
   * @returns {Observable<any>}
   */
  getCallReceived() {
    return this.http.get(constant.URL_DATE_TIME_NOW, this.getHeader()).map(resp => resp.json());
  }

  /**
   * @description
   * @param originLat
   * @param originLong
   * @param destinationLat
   * @param destinationLong
   * @returns {Observable<any>}
   */
  getTotalMiles(originLat, originLong, destinationLat, destinationLong) {
    return this.http.get(constant.URL_DISTANCE_MATRIX + '?origins=' + originLat + ',' + originLong +
        '&destinations=' + destinationLat + ',' + destinationLong, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @description
   * @param calltype
   * @param miles
   * @param appointment
   * @returns {Observable<any>}
   */
  getEstimatedPickup(calltype, miles, appointment) {
    return this.http.get(`${constant.URL_GET_ESTIMATED_PU}callTypeId=${calltype}&miles=${miles}&appointment=${appointment}`,
      this.getHeader()).map(resp => resp.json());
  }

  /**
   * @description
   * @param payorId
   * @param callTypeId
   * @param totalMiles
   * @param brokerid
   * @returns {Observable<any>}
   */
  getTotalAmmount(riderId: number, payorId, callTypeId, totalMiles, dateOfService?, county?: string) {
    return this.http.get(constant.URL_GET_CHARGES_TOTAL +
        '?payorId=' + payorId + '&callTypeId=' + callTypeId +
        '&totalMiles=' + totalMiles +
        '&dateOfService=' + dateOfService + '&riderId=' + riderId +
        '&county=' + county, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @description
   * @param payorid
   * @param totalAmountLyft
   * @param provider
   */
  getAllowMRSAmount(payorid, totalAmountLyft, provider) {
    return this.http.get(
      constant.URL_CALC_MRS_AMOUNT +
      payorid + `/${totalAmountLyft}` + `/${provider}`, this.getHeader())
      .map(resp => resp.json());
  }
  /**
   * @description
   * @param {number} standingOrderId
   */
  getTripsToStandingOrder( standingOrderId: number) {
    return this.http.get(constant.URL_TRIP_STANDING_ORDER + standingOrderId, this.getHeader())
      .map(resp => resp.json());
  }
  /**
   * @description
   * @param data
   * @returns {Observable<any>}
   */
  postDataStandingOrder(data: any) {
    const bodyString = JSON.stringify(data);
    return this.http.post(constant.URL_TRIP_STANDING_ORDER, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  putDataStandingOrderMulti(data: any) {
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_TRIP_STANDING_ORDER, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }


  /**
   * @description
   * @param data
   * @returns {Observable<any>}
   */
  putDataStandingOrder(data: any) {
    delete data.trips[0].triplocations;
    delete data.trips[0].acceptedtimeformatted;
    delete data.trips[0].addedon;
    delete data.trips[0].dateofserviceformatted;
    delete data.trips[0].modifiedon;
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_TRIP_STANDING_ORDER_PUT, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * @description
   * @param data
   * @returns {Observable<any>}
   */
  postData(data: any) {
    const bodyString = JSON.stringify(data);
    return this.http.post(constant.URL_TRIP_SEARCH, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * @description
   * @param dataBefore
   * @returns {Observable<any>}
   */
  putData(dataBefore: any) {
    const user = JSON.parse(localStorage.getItem('currentUser'));
    const token = user ? user.token : '';
    const headers = new Headers({
      'Authorization': 'Session ' + token,
      'Content-Type': 'application/json',
      'Version': this.localVersion,
      'api-version': 2
    });
    const options = new RequestOptions({
      headers: headers
    });
    const data = JSON.parse(JSON.stringify(dataBefore));
    delete data.triplocations;
    delete data.acceptedtimeformatted;
    delete data.addedon;
    delete data.dateofserviceformatted;
    delete data.rider;
    delete data.standingorder;
    delete data.triplocationpickup.modifier;
    delete data.triplocationdropoff.modifier;
    delete data.driver;
    delete data.depot;
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_TRIP_SEARCH, bodyString, options)
      .map((res: Response) => res.json())
      .catch((error: any) =>  this.validate401Error(error, this.route));
  }

  /**
   * @description
   * @param idate
   * @param eDate
   * @param compIds
   * @param vehicleArray
   * @param isUnassigned
   * @returns {Observable<any>}
   */
  getTripsUnassigned(idate, eDate, compIds, vehicleArray, isUnassigned) {
    const data = {
      servicedate: idate,
      vehicles: vehicleArray,
      companyIds: compIds,
      includeunassigned: isUnassigned,
      listtype: 'TripsToSchedule'
    };

    const string = JSON.stringify(data);
    const url = constant.URL_TRIP_SEARCH + '/List';
    return this.http.post(url, string, this.headerPost()).map(resp => resp.json());
  }

  /**
   * @description
   * @returns {Observable<any>}
   */
  getTimeNow() {
    return this.http.get(constant.URL_DATE_TIME_NOW, this.getHeader()).
    map(resp => resp.json());
  }

  /**
   * @description
   * @param companyIds
   * @param isUnassigned
   * @param idate
   * @returns {Observable<any>}
   */
  getTripsByVehicleToDispach(companyIds, isUnassigned, idate) {
    const data = {
      servicedate: idate,
      companyIds: companyIds,
      listtype: 'TripsToDispatch'
    };
    const bodyString = JSON.stringify(data);
    const url = constant.URL_TRIP_SEARCH + '/TripsByVehicles';
    return this.http.post(url, bodyString, this.headerPost())
      .map(resp => resp.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @description
   * @param companyIds
   * @returns {Observable<any>}
   */
  getVehicleToCompany(companyIds) {
    const url = constant.URL_VEHICLE_COMPANY + companyIds;
    return this.http.get(url, this.getHeader())
      .map(resp => resp.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @description
   * @param companyIds
   * @param isUnassigned
   * @returns {Observable<any>}
   */
  getTripsByVehicleToDispatchReserv(companyIds, isUnassigned) {
    const data = {
      companyIds: companyIds,
      listtype: 'VehiclesByCompany'
    };
    const bodyString = JSON.stringify(data);
    const url = constant.URL_TRIP_SEARCH + '/TripsByVehicles';
    return this.http.post(url, bodyString, this.headerPost())
      .map(resp => resp.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
  /**
   * se modificó para crear nuevo servicio
   * @returns {Observable<R>}
   */
  getTripsDispach(idate, eDate, compId, vehicleArray, isUnassigned) {
    const data = {
      servicedate: idate,
      vehicles: vehicleArray,
      companyIds: compId,
      includeunassigned: isUnassigned,
      listtype: 'TripsToDispatch'
    };
    const string = JSON.stringify(data);
    const url = constant.URL_TRIP_SEARCH + '/List';
    return this.http.post(url, string, this.headerPost())
      .map(resp => resp.json());
  }

  /**
   * @description
   * @param idate
   * @param eDate
   * @param compId
   * @param vehicleArray
   * @param isUnassigned
   * @returns {Observable<any>}
   */
  getTripsDispachHistory(idate, eDate, compId, vehicleArray, isUnassigned) {
    const data = {
      servicedate: idate,
      servicedateEnd: idate,
      vehicles: [],
      companyIds: [],
      includeunassigned: isUnassigned,
      listtype: 'AllTrips'
    };

    const string = JSON.stringify(data);
    const url = constant.URL_TRIP_SEARCH + '/List';
    return this.http.post(url, string, this.headerPost())
      .map(resp => resp.json());
  }

  /**
   * @description
   * @param dos
   * @param {boolean} showReroute
   * @returns {Observable<any>}
   */
  getAllTrips(dos, showReroute ?: boolean, IncludeCanceled ?: boolean, filterId?: number) {
    const data = {
      servicedate: dos,
      servicedateEnd: dos,
      vehicles: [],
      companyIds: [],
      includeunassigned: true,
      listtype: 'AllTrips',
      showreroute: showReroute,
      IncludeCanceled,
      filterId
    };
    const string = JSON.stringify(data);
    const url = constant.URL_TRIP_SEARCH + '/List';
    return this.http.post(url, string, this.headerPost())
      .map(resp => resp.json());
  }

  /**
   * @description
   * @param idate
   * @param eDate
   * @param compId
   * @param vehicleArray
   * @param isUnassigned
   * @returns {Observable<any>}
   */
  getTripsProviders(idate, eDate, compId, vehicleArray, isUnassigned) {
    const data = {
      servicedate: idate,
      servicedateEnd: idate,
      vehicles: [],
      companyIds: compId,
      includeunassigned: isUnassigned,
      listtype: 'AllTrips'
    };
    const string = JSON.stringify(data);
    const url = constant.URL_TRIP_SEARCH + '/List';
    return this.http.post(url, string, this.headerPost())
      .map(resp => resp.json());
  }

  /**
   * @description
   * @param idate
   * @param eDate
   * @param compId
   * @param vehicleArray
   * @param isUnassigned
   * @returns {Observable<any>}
   */
  getTripsActive(idate, eDate, compId, vehicleArray, isUnassigned) {
    const data = {
      servicedate: idate,
      vehicles: vehicleArray,
      companyIds: compId,
      includeunassigned: isUnassigned,
      listtype: 'TripsToAssign'
    };
    const string = JSON.stringify(data);
    const url = constant.URL_TRIP_SEARCH + '/List';
    return this.http.post(url, string, this.headerPost())
      .map(resp => resp.json());

  }
  /**
   * @description
   * @param initialDate
   * @param companyIds
   * @returns {Observable<any>}
   */
  getTripsByVehicle(initialDate, companyIds) {
    const data = {
      servicedate: initialDate,
      companyIds: companyIds,
      listtype: 'TripsToSchedule'
    };
    const bodyString = JSON.stringify(data);
    const url = constant.URL_TRIP_SEARCH + '/TripsByVehicles';
    return this.http.post(url, bodyString, this.headerPost())
      .map(resp => resp.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
  /**
   * @description
   * @param data
   * @returns {Observable<any>}
   */
  putReservationHistoryFile(data) {
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_TRIP_HISTORY_ATTACH, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }
  /**
   * @description
   * @param data
   * @returns {Observable<any>}
   */
  postAssignTripsToVehicle(data) {
    const bodyString = JSON.stringify(data);
    return this.http.post(constant.URL_TRIP_SEARCH + '/AssignTripsToVehicle', bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  postReassignTripsToDriver(data) {
    const url = `${constant.URL_TRIP_SEARCH}/AssignDriverAndTripsToVehicle`;
    return this.http
      .post(url, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error));
  }

  /**
   * @description auto asigna los trip por zonas
   * @param tripIds
   * @returns {Observable<any>}
   */
  postAutoAssign(tripIds: number[], date, assignLegBFromLegA?: boolean) {
    const data = JSON.stringify(tripIds);
    const flag = assignLegBFromLegA ? '?assignLegBFromLegA=true' : '';
    return this.http.post(`${constant.URL_TRIP_AUTOASSIGN_DRIVER}/${date}${flag}`, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * @description sync the safety
   * @param data
   * @returns {Observable<any>}
   */
  syncTrips(data) {
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_SYNC_TRIPS, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * @description
   * @param tripId
   * @returns {Observable<any>}
   */
  postEnableTripForm(tripId) {
    const data = {
      'tripid': tripId
    };
    const bodyString = JSON.stringify(data);
    return this.http.post(constant.URL_EDIT_RESERVATION_BTN, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * @description
   * @param tripId
   * @returns {Observable<any>}
   */
  putEnableTripForm(tripId) {
    const data = [tripId];
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_PUT_EDIT_RESERVATION_BTN, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * @description
   * @param data
   * @returns {Observable<any>}
   */
  activateTrips(data) {
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_TRIP_ACTIVATE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * @description
   * @param data
   * @returns {Observable<any>}
   */
  putAssignCompanyToTrip(data) {
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_TRIP_CHANGETRIPSCOMPANY, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * @description
   * @param data
   * @returns {Observable<any>}
   */
  changeStatusTrips(data) {
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_TRIPS_CHANGE_STATUS, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * @description
   * @param SO_Id
   * @param tripstatusid_SO
   * @param tripcancelreasonid_SO
   * @returns {Observable<any>}
   */
  changeStandingOrderStatus(SO_Id, tripcancelreasonid_SO, startDate, endDate) {
    const data = {
      'standingorderid': SO_Id,
      'tripcancelreasonid': tripcancelreasonid_SO
    };
    const bodyString = JSON.stringify(data);
    return this.http.put(
      `${constant.URL_CHANGE_STATUS_SO}/${SO_Id}/CancelStandingOrder?cancelReasonId=${tripcancelreasonid_SO}&startDate=${startDate}&endDate=${endDate}`,
      bodyString, this.headerPost()
      ).map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * @description
   * @param data
   * @returns {Observable<any>}
   */
  getTripsListByRider(data) {
    const bodyString = JSON.stringify(data);
    return this.http.post(constant.URL_TRIP_LIST_BY_RIDER, bodyString, this.headerPost())
      .map(res => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  public getCentrumTripsStatusByRider(riderId: number) {
    return this.http
      .get(`${constant.URL_TRIP_SEARCH}/CentrumTripsStatusByRider?riderId=${riderId}`, this.getHeader())
      .map((response: any) => response.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @description
   * @param {number} riderId
   * @returns {Observable<any>}
   */
  getStandingOrder(riderId: number) {
    return this.http.get(constant.URL_TRIP_STANDING_ORDER_BY_RIDER + riderId, this.getHeader()).map(res => res.json());
  }

  /**
   * @description
   * @param id
   * @returns {Observable<any>}
   */
  public getStandingOrderById(id) {
    return this.http.get(constant.URL_TRIP_STANDING_ORDER_BY_ID + id, this.getHeader()).map(res => res.json());

  }
  /**
   *@description
   * GET RIDER INFORMATION SERVICE
   * @param id
   */
  getRider(id: number, inactive?: boolean) {
    let url = `${constant.URL_RIDER}/${id}`;
    if (inactive) {
      url += `?includeInactive=${inactive}`;
    }
    return this.http.get(url, this.getHeader()).map(
      res => res.json()
    );
  }
  /**
   *@description
   * @param id
   * @returns {Observable<any>}
   */
  getLegsByReservation(id) {
    return this.http.get(constant.URL_LEGS_BY_TRIP + '/' + id, this.getHeader()).map(res => res.json());
  }
  /**
   * @description Este metodo consume cualquier servicio que se requiera por Get, el parametro resource, es el recurso,
   * a consumir.
   * @param {string} resource
   * @returns {Observable<any>}
   */
  getData(resource: string) {
    return this.http.get(constant.BASIC + resource, this.getHeader())
      .map((resp: Response) => resp.json())
      .catch((error: any) =>
        Observable.throw(error.json())
      );
  }
  /**
   * @description
   * @param data
   * @param {string} resource
   * @returns {Observable<any>}
   */
  postDataAny(data: any, resource: string) {
    delete data.charge;
    const bodyString = JSON.stringify(data);
    return this.http.post(constant.BASIC + resource, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
  /**
   * @description
   * @param data
   * @param {string} resource
   * @returns {Observable<any>}
   */
  putDataAny(data: any, resource: string) {
    delete data.charge;
    return this.http.put(constant.BASIC + resource, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
  /**
   * @description
   * update company service
   */
  editCompany(data) {
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_EDIT_COMPANY, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

    /**
   * @description
   * update company service
   */
  changeStandingOrderCompany(data) {
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_CHANGE_COMPANY_SO, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  editCompanyStandingOrder(data) {
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_EDIT_COMPANY_STANDING_ORDER, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * @description
   * update company service
   */
  editBroker(data) {
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_EDIT_BROKER, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }
  /**
   * @description
   * update vehicle and driver service
   */
  editVehicleAndDriver(data) {
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_EDIT_VEHICLE_DRIVER, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   *
   * @param data
   */
  editVehicleAndDriverSO(data) {
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_EDIT_VEHICLE_DRIVER_SO, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   *
   * @param providerid
   */
  getDriversProviderAllByProvider(providerid, providerDriverStatusId?: number) {
    const statusId: string = providerDriverStatusId ? '&providerDriverStatusId=' + providerDriverStatusId : '';
    return this.http
      .get(constant.LIST_URL_DRIVERS_PROVIDER + '/?filter=&providerid=' + providerid + '&showInactive=false' + statusId, this.getHeader())
      .map(res => res.json());
  }
  /**
   * @description
   * REROUTE
   */
  reroute(data) {
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.CHANGE_PROVIDER_STATUS_TRIP_URL, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }
  /**rerouteProvider
   * @description para cambiar el provider y status a un grupo de trip.
   */
  rerouteProvider(data) {
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.CHANGE_PROVIDER_REROUTE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }
  /**
   * @description
   * update only status service
   */
  editStatus(data) {
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_EDIT_STATUS, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * @description
   * @param data
   * @returns {Observable<any>}
   */
  postSaveLayout(data) {
    const bodyString = JSON.stringify(data);
    return this.http.post(constant.URL_SAVE_LAYOUT, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
  /**
   * @description
   * @param id
   * @returns {Observable<any>}
   */
  getRoleActionByModule(id) {
    return this.http.get(constant.URL_GETMODULEACTION + '/' + id, this.getHeader()).map(res => res.json());
  }
  /**
   * @description
   * @param {number} callTypeId
   * @param dateOfService
   * @param {number} brokerId
   * @returns {Observable<any>}
   */
  getAllProvidersNewReservation(callTypeId: number, dateOfService: any, brokerId: number, payorid: number, riderId: number) {
    return this.http.get(constant.USER_PROVIDERS + '&callTypeId=' +
      callTypeId + '&dateOfService=' + dateOfService + '&brokerId=' + brokerId
      + '&payorId=' + payorid + '&RiderId=' + riderId, this.getHeader()).map(res => res.json());
  }

  /**
   * @description
   * @param {number} roleId
   * @returns {Observable<any>}
   */
  public getProviderForRole(roleId: number) {
    return this.http.get(constant.PROVIDER_ROLE_ACTIVE + roleId, this.getHeader()).map(res => res.json());
  }

  /**
   * @name getEobPdf
   * @description return the pdf file
   * @returns {Observable<any>}
   */
  getEobPdf(providerClaimTripId): Observable<any> {
    return this.http.get(
      `${constant.URL_GET_EOB_PDF}/${providerClaimTripId}`, this.getFileHeaders())
      .catch((error: any) => Observable.throw(error));
  }

  sendTripToMCT(data) {
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_SEND_TRIPS_TO_MCT, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * @name getRepotClient
   * @description return report of ClaimTrips
   * @returns {Observable<any>}
   */
  getRepotClaim(tripid): Observable<any> {
    return this.http.get(`${constant.URL_GET_REPORT_CLAIM}/${tripid}`, this.getFileHeaders())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getReportClaims(tripid): Observable<any> {
    return this.http.get(`${constant.URL_GET_REPORT_CLAIMS}/${tripid}`, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }


  /**
   * @description
   * @param {string} ptr
   * @returns {Observable<any>}
   */
  getTodayTripsForReservation(ptr: string) {
    return this.http.get(constant.URL_TRIP_SEARCH_TRIP_TODAY + ptr, this.getHeader())
      .map(resp => resp.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * 🅲hange 🅱illing 🆂tatus
   */

  changeBillingStatus(data) {
    const url = constant.URL_CHANGE_BILLING_STATUS;
    return this.http
      .put(url, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**Para validar que el rider no tenga trip para la fecha
   */
  getValidDateTrip(data) {
    const body = JSON.stringify(data);
    return this.http.post(constant.URL_TRIP_DATE_VALIDATE, body, this.headerPost())
    .map((res: Response) => res.json())
    .catch((error: any) => Observable.throw(error.json()));
  }

  //  _            _          _                  _ _                             _
  // | |          | |        | |                | (_)                           | |
  // | | ___   ___| | __  ___| |_ __ _ _ __   __| |_ _ __   __ _    ___  _ __ __| | ___ _ __
  // | |/ _ \ / __| |/ / / __| __/ _` | '_ \ / _` | | '_ \ / _` |  / _ \| '__/ _` |/ _ \ '__|
  // | | (_) | (__|   <  \__ \ || (_| | | | | (_| | | | | | (_| | | (_) | | | (_| |  __/ |
  // |_|\___/ \___|_|\_\ |___/\__\__,_|_| |_|\__,_|_|_| |_|\__, |  \___/|_|  \__,_|\___|_|
  //                                                        __/ |
  //                                                       |___/

  lockStandingOrder(data) {
    return this.http.post(constant.URL_LOCK_SO + data + '/Lock', null, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  unlockStandingOrder(data) {
    return this.http.delete(constant.URL_LOCK_SO + data + '/Lock', this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @description
   * @param tripId
   * @returns {Observable<any>}
   */
  getHistorySO(standingOrderId) {
    return this.http.get(constant.URL_SO_HISTORY + standingOrderId, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @description
   * @param data
   * @returns {Observable<any>}
   */
  putSOHistoryFile(data) {
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_SO_HISTORY_ATTACH, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  removeSignalRConn(connId) {
    return this.http
    .delete(constant.URL_HUB_EDIT_RESERVATION + connId, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getTripsMadeByRider(data: any) {
    return this.http.post(constant.TRIPS_MADE_BY_RIDER, JSON.stringify(data), this.headerPost()).map(resp => resp.json());
  }

  putProviderNegociateRate(data: any) {
    return this.http.put(`${constant.URL_BILLING.TRIP_CHARGE.CHANGE_PROVIDER_BILLING}`, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch(error => Observable.throw(error.json()));
  }

  putProviderNegociateRateSo(data: any) {
    return this.http.put(`${constant.URL_BILLING.TRIP_CHARGE.CHANGE_PROVIDER_BILLING_SO}`, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch(error => Observable.throw(error.json()));
  }

  putClientNegotiatedRate(data: any) {
    return this.http.put(`${constant.URL_BILLING.TRIP_CHARGE.CHANGE_CLIENT_BILLING}`, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch(error => Observable.throw(error.json()));
  }

  putClientNegotiatedRateSo(data: any) {
    return this.http.put(`${constant.URL_BILLING.TRIP_CHARGE.CHANGE_CLIENT_BILLING_SO}`, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch(error => Observable.throw(error.json()));
  }

  getTripNegotiatedRate(tripid: number) {
    return this.http.get(`${constant.URL_BILLING.TRIP_CHARGE.IS_NEGOTIATED_RATE_TRIP}/${tripid}`, this.getHeader())
      .map(resp => resp.json())
      .catch(error => Observable.throw(error.json()));
  }

  putTimeServiceSo(data: any) {
    return this.http.put(`${constant.URL_BILLING.TRIP_CHARGE.CHANGE_TIME_SO}`, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch(error => Observable.throw(error.json()));
  }

  getGoogleOdrdGuid() {
    return this.http.get(constant.URL_GOOGLE_ODRD_GUID, this.getHeader())
      .map((res: Response) => res.json())
      .catch(error => Observable.throw(error.json()));
  }

  getRerouteReasonList(): Observable<any> {
    return this.http.get(constant.REROUTE_REASON_LIST, this.getHeader())
      .map((res: Response) => res.json())
      .catch(error => Observable.throw(error.json()));
  }

  getCountLegsReservation(reservationId: number) {
    return this.http
      .get(
        `${constant.URL_COUNT_LEGS_RESERVATION + reservationId}`,
        this.headerPost()
      )
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getStandingOrderByDate(data: any): Observable<any> {
    return this.http
      .post(
        constant.URL_TRIP_STANDING_ORDER_GET_BY_DATE,
        data,
        this.headerPost()
      )
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  setRiderData(data: ITripRiderRequest) {
    this.riderData.next(data);
  }

  emitClaimGridLocalUpdate(data: {
    tripid: number;
  }): void {
    this.claimGridLocalUpdate.next(data);
  }

  getEncounterHistoryByTripId(tripId: number) {
    return this.http
      .get(
        `${constant.URL_FORMEXPORT_GET_ENCOUNTERHISTORY}/${tripId}`,
        this.getHeader()
      )
      .map((resp) => resp.json())
      .catch((error) => Observable.throw(error.json()));
  }

  setEncounterData(data: {
    tripId: number;
    tripPaymentDate: string;
    encounterStatus: string;
    planType: string;
    region: string;
    showButton: boolean;
  }): void {
    this.modelEncounter.next(data);
  }

  sentToTripsToExternalSystem(data: any) {
    const bodyString = JSON.stringify(data);
    return this.http
      .post(
        constant.URL_EXTERNAL_INTEGRATION_SEND_TRIPS,
        bodyString,
        this.headerPost()
      )
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  hasExternalSetting(providerId: number) {
    return this.http
      .get(
        `${constant.URL_EXTERNAL_INTEGRATION_HAS_EXTERNAL_SETTING}/${providerId}`,
        this.getHeader()
      )
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  setStandingOrderTrips(standingOrderTrips: any): void {
    this.standingOrderTrips.next(standingOrderTrips);
  }

  setVehicleIdAndDriverId(payload: { vehicleId: number, driverId: number }) {
    this.driverAndVehicleIdByEditDriverVehicleComponentSubject.next(payload);
  }

  setUpdateEncounterHistory(tripId: number) {
    this.updateEncounterHistory.next(tripId);
  }

  setReadOnly(value: boolean) {
    this.isReadOnlySubject.next(value);
  }
  getListLinkedProvider(companyId: number) {
    return this.http.get(`${constant.URL_LINKEDPROVIDER}/${companyId}` , this.getHeader())
      .map((res: Response) => res.json())
      .catch(error => Observable.throw(error.json()));
  }

  getActiveTrips() {
    return this.http
      .get(`${constant.URL_GET_ACTIVE_TRIPS_BY_PROVIDER}`, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  downloadBillingReport(tripid: number): Observable<any> {
    return this.http
      .get(
        `${constant.URL_TRIP_DOWNLOAD_BILLING_REPORT}/${tripid}`,
        this.getHeader()
      )
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getTripPaymentReceiptByTripId(tripId: number): Observable<string> {
    return this.http
      .get(`${constant.URL_TRIP_PAYMENT_RECEIPT_BY_TRIP_ID}/${tripId}`, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  public sendTripTrackingToTheRider(tripId: number) {
    return this.http
      .get(`${constant.URL_LIVE_TRIP_SEND_TRACKING}/${tripId}`, this.getHeader())
      .map((response: any) => response.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/reservations.service.ts